$(".bulletin").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    arrows: false
});

$(".goodiesSliderMob").slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true,
            dots: false,
            mobileFirst: true,
            responsive: [
                {
                breakpoint: 989,
                lazyLoad: 'progressive',
                settings: "unslick",
                }, 
             
            ],
});

// sidebar sliding function
function showCartModal(product) {
   ajaxfetchCart(product);
    $("body").removeClass("showModal showAccountModal"),
        $("body").addClass("showModal showCartModal"),
        $(".trulySidebarModelOverlay").fadeIn(100),
        $(".cart_favorite_item_slider").resize()
}

function showAccountModal() {
    $("body").removeClass("showModal showCartModal"),
        $("body").addClass("showModal showAccountModal"),
        $(".trulySidebarModelOverlay").fadeIn(100)
   // add new
        $('.desktop_menu_wrapper').removeClass('desktop_slide')
        $("body").removeClass("showSearch_modal")
        $(".menuSearchWrap").removeClass("searchOpen")
        $(".searchBtnIcon").removeClass("active")
        $('html').removeClass('deskop_layer')
        $('html').removeClass('showNav')
}


function hideModal() {
    $("body").removeClass("showModal showAccountModal showCartModal showSearchModal"),
      $("html").removeClass("noscroll"),
        $(".trulySidebarModelOverlay").fadeOut(100)
}

function showSignup() {
    $(".modeSignupForm").show(),
        $(".modeLoginForm").hide(),
        $(".modeForgetForm").hide()
}

function showLogin() {
    $(".modeLoginForm").show(),
        $(".modeSignupForm").hide(),
        $(".modeForgetForm").hide()
}

function showforgot() {
    $(".modeLoginForm").hide(),
        $(".modeSignupForm").hide(),
        $(".modeForgetForm").show()
}


// mobile nav toggle
$(".main-menuBar-toggleBtn").click(function () {
    $("body").toggleClass("open_nav");
    $(".main-menuBar-menuholder").slideToggle(300);
});

$(".main-title-mega-menu").click((function () {
    $(this).parent().siblings().removeClass("active"),
        $(this).parent().siblings().find(".quick-links").slideUp(),
        $(this).next(".quick-links").slideToggle(),
        $(this).parent().toggleClass("active")
}))



/*Heart on cart button*/
jQuery.rnd = function (m, n) {
    m = parseInt(m);
    n = parseInt(n);
    return Math.floor(Math.random() * (n - m + 1)) + m;
}

$('.showHeart').mouseenter(function () {
    var heartcount = ($(this).width() / 90) * 5;
    for (var i = 0; i <= heartcount; i++) {
        var size = ($.rnd(60, 120) / 10);
        $(this).append('<span class="particle" style="top:' + $.rnd(20, 140) + '%; left:' + $.rnd(0, 100) + '%;width:' + size + 'px; height:' + size + 'px;animation-delay: ' + ($.rnd(0, 30) / 5) + 's;"></span>');
    }
});

$('.showHeart').mouseleave(function () {
    $(this).find('span.particle').remove();
});

function togglePassword() {
     var x = document.getElementById("RegisterForm-password");
       var y = document.getElementById("customer_password");
     var z = document.getElementById("ResetPassword");
    var z = document.getElementById("password");
     
    if (document.getElementById('RegisterForm-password') != null) {
     if (x.type === "password") {
       x.type = "text";
       $(".passworEye img").css({"opacity": "1"}); 
     } else {
       x.type = "password";
       $(".passworEye img").css({"opacity": "0.5"}); 
     }
   }
      if (document.getElementById('customer_password') != null) {

       if (y.type === "password") {
       y.type = "text";
       $(".passworEye img").css({"opacity": "1"}); 
     } else {
       y.type = "password";
       $(".passworEye img").css({"opacity": "0.5"}); 
     }
      }
   
     if (document.getElementById('ResetPassword') != null) {

     if (z.type === "password") {
       z.type = "text";
       $(".passworEye img").css({"opacity": "1"}); 
     } else {
       z.type = "password";
       $(".passworEye img").css({"opacity": "0.5"}); 
     }
     }
    if (document.getElementById('password') != null) {

     if (z.type === "password") {
       z.type = "text";
       $(".infpassworEye img").css({"opacity": "1"}); 
     } else {
       z.type = "password";
       $(".infpassworEye img").css({"opacity": "0.5"}); 
     }
     }
   }

 $(function() {
 if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
 $('body').addClass('safari-mac');
 }
 });

/**before-after*****/
if ($(".beforeAfter__Result").length > 0) {  
function moveDivisor() {
            if (slider.value > 2 && slider.value < 98) {
                handle.style.left = slider.value + "%";
                divisor.style.width = slider.value + "%";
            }
 }

window.onload = function () {
            moveDivisor();
};  
(function ($) {
 $(document).ready(function () {
                // Before After Compare Slider
                var divisor = document.getElementById("divisor"),
                    handle = document.getElementById("handle"),
                    slider = document.getElementById("slider");
});
})(jQuery);        
}

// Only One video At a time
document.addEventListener('play', function (e) {
    var videos = document.getElementsByTagName('video');
    for (var i = 0, len = videos.length; i < len; i++) {
        if (videos[i] != e.target) {
            videos[i].pause();
            $(videos[i]).parents('.twoboxvideoslider').removeClass("active");
            $(videos[i]).parents('.boxVideo').removeClass("active");
            $(videos[i]).parent().find('.boxVideo__btn').removeClass("active");
        }
    }
}, true);

//smoothscroll
$(".smoothScroll").on('click', function(event) {
    if (this.hash !== "") {
    event.preventDefault();
     // Store hash
     var hash = this.hash;
      $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ window.location.hash = hash;});
      } // End if
 });

 $(document).on("click",".popup_freebie_close",function () {
              $(this).parents("#popup_freebie").css('display','none').html('');
       $("html").removeClass("no-scroll")
});
  
//video-mute
 var video = document.getElementById("myVideo");
   
   if ($("#myVideo").prop("muted", !0)) {
   
       $("#muteSound img").click((function () {
           $(this).removeClass("active"),
               $(this).next("img").addClass("active")
       })),
           $("#muteSound .mute").click((function () {
               video.volume = .2,
                   $("#myVideo").prop("muted", !1)
           })),
           $(".vol1").click((function () {
               video.volume = .5,
                   $("#myVideo").prop("muted", !1)
           })),
           $(".vol2").click((function () {
               video.volume = 1,
                   $("#myVideo").prop("muted", !1)
           })),
           $(".vol3").click((function () {
               $(".mute").addClass("active"),
                   $("#myVideo").prop("muted", !0)
           }))
   
   }

/** joinknowledgefrom* */
$("form#joinknowledgefrom").submit(function(){
  //console.log('joinuss');
       email = $("#jksubscribeemail");
         if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val('Enter valid email address');}
       if ($(":input").hasClass("needsfilled")) { 
           return false;
       }else {
         var useremail =$("#jksubscribeemail").val();
         $.ajax({
           url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
           type: 'POST',
           data: {ajaxaction:"subscribelist",subemailaddress:useremail},
           async: true,
           success: function (response) { 
             $("form#joinknowledgefrom").get(0).reset()
               alert('Thanks for joining our Join Knowledge.');
               },
           timeout: 5000000, // sets timeout to 5 seconds
           }); 
       
         return false;
       }
});

            $(".close_announcement,.close_announcement-i").click(function () {
                $(".header_announcements_s").hide();
              $(".header_announcementstime").hide();
               getHeight();
            });
 function getHeight(){
            var height = $('#HeaderContent').outerHeight();
            $(':root').css('--header-height', height + 'px'); 
        }
 getHeight();
var saveonsets = {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            autoplay: false,
            responsive: [
                { breakpoint: 1251, settings: { slidesToShow: 1, } },
                { breakpoint: 1101, settings: { slidesToShow: 1, } },
                { breakpoint: 751, settings: { slidesToShow: 1.2 } },
            ]
        };
  $('#saveonsets_sliders').slick(saveonsets);
        var compareSlider = {
            draggable: false,
            swipeToSlide: false,
            accessibility: false,
            swipe: false,
            touchMove: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,

            prevArrow: document.getElementsByClassName("slider_nav_arrow btnleft"),
            nextArrow: document.getElementsByClassName("slider_nav_arrow btnright"),
        };

         $('.compare_slider').slick(compareSlider);

        document.addEventListener("DOMContentLoaded", function () {
            document.querySelectorAll('.before_aftercomparsion').forEach(function (container) {
                const divisor = container.querySelector('.divisor-inside');
                const handle = container.querySelector('.handle-inside');
                const slider = container.querySelector('.slider-slides');

                function moveDivisor() {
                    const value = slider.value;
                    if (value > 2 && value < 98) {
                        handle.style.left = value + "%";
                        divisor.style.width = value + "%";
                    }
                }

                // Initial position
                moveDivisor();

                // Bind input
                slider.addEventListener('input', moveDivisor);
            });
        });

$("form#pagesubscribeform").submit(function(){
          email = $("#email_coco-cloud");
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {
            email.addClass("needsfilled");email.val('Enter valid email address');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else {
            $('button#cococloudsubscribe').css("pointer-events", "none");
            var useremail =$("#email_coco-cloud").val();
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
              type: 'POST',
              data: {ajaxaction:"subscribelist",subemailaddress:useremail},
              async: true,
              success: function (response) {
                $("form#pagesubscribeform").get(0).reset()
                alert('Thanks for subscribe.');
                $('button#cococloudsubscribe').css("pointer-events", "auto");
              },
              timeout: 5000000, // sets timeout to 5 seconds
            });

            return false;
          }

        });

$('.into_product_slider').each(function () {
            const slidesToShow = $(this).data('slides') || 3; 

            $(this).slick({
                infinite: false,
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: false,
                responsive: [
                    { breakpoint: 1250, settings: { slidesToShow: 3 } },
                    { breakpoint: 1100, settings: { slidesToShow: 2 } },
                    { breakpoint: 750, settings: { slidesToShow: 1.2 } },
                ],
            });
        });

         // new script added
      $('.blogs_product_slider').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: false,
        responsive: [
            { breakpoint: 1251, settings: { slidesToShow: 3, } },
            { breakpoint: 1101, settings: { slidesToShow: 2, } },
            { breakpoint: 750, settings: { slidesToShow: 1.4, } },
        ]
      });
      $('#product_slider_article').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          autoplay: false,
          responsive: [
              { breakpoint: 1251, settings: { slidesToShow: 3, } },
              { breakpoint: 1101, settings: { slidesToShow: 2, } },
              { breakpoint: 750, settings: { slidesToShow: 1.2, } },
          ]
      });
      if ($("body").hasClass("template-article")) {
        alltags = ["p","h2","h3","h4","h5","h6"];
        alltags.forEach(element => {
          var tagnames = document.getElementsByTagName(element);
          for (var i = tagnames.length - 1; i >= 0; i--) {
              var tagname = tagnames[i];
              // Check if the tagname's innerHTML, after trimming whitespace and removing <br> tags, is empty
              if (tagname.innerHTML.replace(/(<strong[^>]*>|<\/strong>|<span[^>]*>|<\/span>|<br[^>]>|\s|&nbsp;)+/gi, "").trim().length === 0) {
                //tagname.style.backgroundColor = 'yellow';
                  tagname.parentNode.removeChild(tagname);
              }
          }
        });
      }  

   // strawberry product page added. 
   
//Get header height

function getHeaderHeight() {
    let height = $(".header_navigation").outerHeight();
    $(":root").css("--header-height", height + "px")
}
// Header fixed
$(window).scroll(function() {
    let scroll = $(window).scrollTop();
    if (scroll >= 60) {
        getHeaderHeight()
        $('.main_header').addClass("fixed");
    } else {
    $(":root").css("--header-height", 0)
        $('.main_header').removeClass("fixed");
    }
});
$(".header_toggle").click(function () {
    if ($(window).width() <= 989) {
        $('body').addClass('no-scroll');
        $('.header_overlay').addClass('active');
        $('.header_menu').addClass('show');
    }
});
$(".menu_close-btn, .header_overlay").click(function () {
    if ($(window).width() <= 989) {
        $('body').removeClass('no-scroll');
        $('.header_overlay').removeClass('active');
        $('.header_menu').removeClass('show');
    }
});

